// EZ Reviews' automatic card detection runs once. Keep its supported
// placeholders populated when Horizon replaces or appends collection cards.
const selector = '[data-ez-card-rating]';
const cache = new Map();
const attempted = new Set();
let timer;
let loading = false;
let queued = false;

function describeRating(slot) {
  const rating = slot.querySelector('.rev-titl-wp')?.getAttribute('title');
  const count = slot.querySelector('.nub-rev-tt')?.textContent.trim();
  if (rating) {
    slot.setAttribute('role', 'img');
    slot.setAttribute('aria-label', `${rating} out of 5 stars${count ? `, ${count.replace(/[()]/g, '')} reviews` : ''}`);
  }
}

async function hydrate() {
  if (loading) {
    queued = true;
    return;
  }
  const slots = [...document.querySelectorAll(selector)];
  const ids = new Set();
  for (const slot of slots) {
    const id = slot.dataset.productId;
    if (!/^\d+$/.test(id || '')) continue;
    if (slot.querySelector('.fx-star-under-title-list')) {
      cache.set(id, slot.innerHTML);
      describeRating(slot);
    } else if (cache.has(id)) {
      slot.innerHTML = cache.get(id);
      describeRating(slot);
    } else if (!attempted.has(id)) {
      ids.add(id);
    }
  }
  if (!ids.size || !window.Shopify?.shop) return;

  loading = true;
  ids.forEach((id) => attempted.add(id));
  const body = new URLSearchParams({ storeUrl: window.location.href });
  ids.forEach((id) => body.append('productIds[]', id));
  try {
    // Same read-only ratings endpoint used by the installed EZ Reviews script.
    const response = await fetch(
      `https://dev.younet.network/importreview/ajaxStarUnderProductList?shop=${encodeURIComponent(window.Shopify.shop)}`,
      { method: 'POST', body, signal: AbortSignal.timeout(15000) }
    );
    if (!response.ok) throw new Error(`Ratings request failed (${response.status})`);
    const text = await response.text();
    const ratings = text.trim() ? JSON.parse(text) : {};
    for (const id of ids) {
      const content = ratings[id]?.content;
      // Unreviewed products stay empty; never manufacture a rating.
      cache.set(id, typeof content === 'string' ? content : '');
    }
    for (const slot of document.querySelectorAll(selector)) {
      if (!slot.querySelector('.fx-star-under-title-list') && cache.has(slot.dataset.productId)) {
        slot.innerHTML = cache.get(slot.dataset.productId);
      }
      describeRating(slot);
    }
  } catch (error) {
    console.warn('[EZ Reviews cards] Could not load product ratings.', error);
  } finally {
    loading = false;
    if (queued) {
      queued = false;
      schedule();
    }
  }
}

function schedule() {
  clearTimeout(timer);
  timer = setTimeout(hydrate, 250);
}

const observer = new MutationObserver((mutations) => {
  if (mutations.some(({ addedNodes }) => [...addedNodes].some(
    (node) => node instanceof Element &&
      (node.matches(selector) || node.querySelector(selector))
  ))) schedule();
});
observer.observe(document.querySelector('#MainContent') || document.body, { childList: true, subtree: true });
document.addEventListener('shopify:section:load', schedule);
// Give the app's normal initial render a chance to fill the placeholders first.
timer = setTimeout(hydrate, 1200);